import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import Button from '@mui/material/Button';
import Alert from '../../Alert';
import CircularProgress from '@mui/material/CircularProgress';
import OrderCard from '../../OrderCard';
import SectionTitle from '../../SectionTitle';

// Styles
import styles from './index.module.sass';

//Queries
import getValidarCelularSMS from '../../Queries/getValidarCelularSMS';

const Validate = (props) => {
  const { device, getCookie, setSessionMessage } = props;
  const { screenSize } = device;
  const { t } = useTranslation('validate');
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [alertText, setAlertText] = useState('');
  const [alertTitle, setAlertTitle] = useState(t('title'));
  const [form, setForm] = useState({
    num1: '',
    num2: '',
    num3: '',
    num4: '',
    num5: '',
    num6: '',
    num7: '',
    num8: '',
    num9: '',
    num10: '',
    code1: '',
    code2: '',
    code3: '',
    code4: '',
    code5: '',
    code6: '',
  });

  const handleChange = (e, type) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const changeFocus = (type) => {
    document.getElementById(type).focus();
  };

  async function handleSubmit(e, type) {
    setLoading(true);
    let cellphone =
      form.num1 +
      form.num2 +
      form.num3 +
      form.num4 +
      form.num5 +
      form.num6 +
      form.num7 +
      form.num8 +
      form.num9 +
      form.num10;

    let code = form.code1 + form.code2 + form.code3 + form.code4 + form.code5 + form.code6;

    if (type === 'validate') {
      if (cellphone === '') {
        setOpen(true);
        setAlertText(t('alertPhone'));
        setLoading(false);
        return;
      }
      if (code === '') {
        setOpen(true);
        setAlertText(t('alertCode'));
        setLoading(false);
        return;
      }
    }

    const response = await getValidarCelularSMS(getCookie('usuarioOk'), cellphone, code);
    const { tipoMensaje = 'error', mensaje = '', celular = '' } = response;

    setSessionMessage(mensaje);

    if (tipoMensaje === 'error') {
      setAlertText(mensaje);
      setOpen(true);
    } else {
      if (type === 'send') {
        setAlertText(t('alertSend'));
        setAlertTitle(t('alertTitle'));
        form.num1 = celular.toString().substring(0, 1);
        form.num2 = celular.toString().substring(1, 2);
        form.num3 = celular.toString().substring(2, 3);
        form.num4 = celular.toString().substring(3, 4);
        form.num5 = celular.toString().substring(4, 5);
        form.num6 = celular.toString().substring(5, 6);
        form.num7 = celular.toString().substring(6, 7);
        form.num8 = celular.toString().substring(7, 8);
        form.num9 = celular.toString().substring(8, 9);
        form.num10 = celular.toString().substring(9, 10);
        setOpen(true);
      } else {
        setOpen(true);
        setAlertText(t('alertSend2'));
        setAlertTitle(t('alertTitle2'));
      }
    }
    setLoading(false);
  }

  function restrictChars($event, type) {
    if ($event.charCode === 0 || /\d/.test(String.fromCharCode($event.charCode))) {
      document.getElementById(type).focus();
      return true;
    } else {
      $event.target.focus();
      $event.preventDefault();
    }
  }

  return (
    <div id={styles.Validate} className={`${styles[screenSize]} ${styles.validate}`}>
      <Alert open={open} setOpen={setOpen} title={alertTitle} text={alertText} />
      <div className={styles.dobleCard}>
        <div className={screenSize === 'phone' ? styles.leftRowMobile : styles.leftRow}>
          <div className={styles.columnCard}>
            <SectionTitle title={t('headerGold')} subtitle={t('headerBlue')} />
            <OrderCard title={t('textCardOne')} iconColor='colorless'>
              <div className={styles.subTitle}>{t('labelCardOne')}</div>
              <Button
                type='submit'
                variant='contained'
                color='primary'
                className={`${styles.button}`}
                onClick={(e) => handleSubmit(e, 'send')}>
                {(loading && <CircularProgress />) || (
                  <div className={styles.divButton}>
                    {t('textButton')} &nbsp;
                    <span className={`material-icons-outlined`}>arrow_right_alt</span>
                  </div>
                )}
              </Button>
            </OrderCard>

            <OrderCard title={t('textCardTwo')} iconColor='colorless'>
              <div className={styles.subTitle}>{t('labelCardTwo')}</div>
              <div className={styles.subTitleGold}>{t('cel')}</div>
              <div>
                <input
                  type='text'
                  className={styles.textNumber}
                  maxLength='1'
                  name='num1'
                  id='num1'
                  autoFocus={true}
                  value={form.num1 || ''}
                  onChange={(e) => handleChange(e)}
                  onKeyUp={(e) => changeFocus('num2')}
                  onKeyPress={(e) => restrictChars(e, 'num2')}
                />
                <input
                  type='text'
                  className={styles.textNumber}
                  maxLength='1'
                  name='num2'
                  id='num2'
                  value={form.num2 || ''}
                  onChange={(e) => handleChange(e)}
                  onKeyUp={(e) => changeFocus('num3')}
                  onKeyPress={(e) => restrictChars(e, 'num3')}
                />
                <input
                  type='text'
                  className={styles.textNumber}
                  maxLength='1'
                  name='num3'
                  id='num3'
                  value={form.num3 || ''}
                  onChange={(e) => handleChange(e)}
                  onKeyUp={(e) => changeFocus('num4')}
                  onKeyPress={(e) => restrictChars(e, 'num4')}
                />
                <input
                  type='text'
                  className={styles.textNumber}
                  maxLength='1'
                  name='num4'
                  id='num4'
                  value={form.num4 || ''}
                  onChange={(e) => handleChange(e)}
                  onKeyUp={(e) => changeFocus('num5')}
                  onKeyPress={(e) => restrictChars(e, 'num5')}
                />
                <input
                  type='text'
                  className={styles.textNumber}
                  maxLength='1'
                  name='num5'
                  id='num5'
                  value={form.num5 || ''}
                  onChange={(e) => handleChange(e)}
                  onKeyUp={(e) => changeFocus('num6')}
                  onKeyPress={(e) => restrictChars(e, 'num6')}
                />
                <input
                  type='text'
                  className={styles.textNumber}
                  maxLength='1'
                  name='num6'
                  id='num6'
                  value={form.num6 || ''}
                  onChange={(e) => handleChange(e)}
                  onKeyUp={(e) => changeFocus('num7')}
                  onKeyPress={(e) => restrictChars(e, 'num7')}
                />
                <input
                  type='text'
                  className={styles.textNumber}
                  maxLength='1'
                  name='num7'
                  id='num7'
                  value={form.num7 || ''}
                  onChange={(e) => handleChange(e)}
                  onKeyUp={(e) => changeFocus('num8')}
                  onKeyPress={(e) => restrictChars(e, 'num8')}
                />
                <input
                  type='text'
                  className={styles.textNumber}
                  maxLength='1'
                  name='num8'
                  id='num8'
                  value={form.num8 || ''}
                  onChange={(e) => handleChange(e)}
                  onKeyUp={(e) => changeFocus('num9')}
                  onKeyPress={(e) => restrictChars(e, 'num9')}
                />
                <input
                  type='text'
                  className={styles.textNumber}
                  maxLength='1'
                  name='num9'
                  id='num9'
                  value={form.num9 || ''}
                  onChange={(e) => handleChange(e)}
                  onKeyUp={(e) => changeFocus('num10')}
                  onKeyPress={(e) => restrictChars(e, 'num10')}
                />
                <input
                  type='text'
                  className={styles.textNumber}
                  maxLength='1'
                  name='num10'
                  id='num10'
                  value={form.num10 || ''}
                  onChange={(e) => handleChange(e)}
                  onKeyUp={(e) => changeFocus('code1')}
                  onKeyPress={(e) => restrictChars(e, 'code1')}
                />
              </div>
              <div className={styles.subTitleGold}>{t('codigo')}</div>
              <div>
                <input
                  type='text'
                  className={styles.textNumber}
                  maxLength='1'
                  name='code1'
                  id='code1'
                  value={form.code1 || ''}
                  onChange={(e) => handleChange(e)}
                  onKeyUp={(e) => changeFocus('code2')}
                  onKeyPress={(e) => restrictChars(e, 'code2')}
                />
                <input
                  type='text'
                  className={styles.textNumber}
                  maxLength='1'
                  name='code2'
                  id='code2'
                  value={form.code2 || ''}
                  onChange={(e) => handleChange(e)}
                  onKeyUp={(e) => changeFocus('code3')}
                  onKeyPress={(e) => restrictChars(e, 'code3')}
                />
                <input
                  type='text'
                  className={styles.textNumber}
                  maxLength='1'
                  name='code3'
                  id='code3'
                  value={form.code3 || ''}
                  onChange={(e) => handleChange(e)}
                  onKeyUp={(e) => changeFocus('code4')}
                  onKeyPress={(e) => restrictChars(e, 'code4')}
                />
                <input
                  type='text'
                  className={styles.textNumber}
                  maxLength='1'
                  name='code4'
                  id='code4'
                  value={form.code4 || ''}
                  onChange={(e) => handleChange(e)}
                  onKeyUp={(e) => changeFocus('code5')}
                  onKeyPress={(e) => restrictChars(e, 'code5')}
                />
                <input
                  type='text'
                  className={styles.textNumber}
                  maxLength='1'
                  name='code5'
                  id='code5'
                  value={form.code5 || ''}
                  onChange={(e) => handleChange(e)}
                  onKeyUp={(e) => changeFocus('code6')}
                  onKeyPress={(e) => restrictChars(e, 'code6')}
                />
                <input
                  type='text'
                  className={styles.textNumber}
                  maxLength='1'
                  name='code6'
                  id='code6'
                  value={form.code6 || ''}
                  onChange={(e) => handleChange(e)}
                  onKeyPress={(e) => restrictChars(e, 'code6')}
                />
              </div>
              {!loading && (
                <Button
                  type='submit'
                  variant='contained'
                  color='primary'
                  className={`${styles.button}`}
                  onClick={(e) => handleSubmit(e, 'validate')}>
                  {(loading && <CircularProgress />) || (
                    <div className={styles.divButton}>
                      {t('textButton')} &nbsp;
                      <span className={`material-icons-outlined`}>arrow_right_alt</span>
                    </div>
                  )}
                </Button>
              )}
            </OrderCard>
          </div>
        </div>

        {screenSize !== 'phone' && (
          <div className={styles.rightRow}>
            <OrderCard>
              <div className={styles.title}>
                <div>
                  <span className={`material-icons-outlined ${styles.tooltip}`}>info</span>
                </div>
                <div>{t('ValidateSMS')}</div>
              </div>
              <div className={styles.subTitle}>{t('ValidateSMSTwo')}</div>
              <div className={styles.subTitle}>{t('ValidateSMST')}</div>
            </OrderCard>
          </div>
        )}
      </div>
    </div>
  );
};

export default Validate;
